// src/hooks/useSession.js
import { useState, useCallback } from 'react';
import { fetchMessagesWithToken, persistMessageWithToken } from '../api/ai';

export function useSession(getToken) {
  const [sessionId, setSessionId] = useState(
    () => crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`
  );
  const [sessionFull, setSessionFull] = useState(false);

  const startNewSession = useCallback(() => {
    const newId = crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`;
    setSessionId(newId);
    setSessionFull(false);
    return newId;
  }, []);

  const loadSessionMessages = useCallback(async (sid) => {
    const token = getToken();
    if (!token) return [];
    try {
      const data = await fetchMessagesWithToken(token, sid);
      return (Array.isArray(data) ? data : []).map(msg => ({
        id: msg.id,
        role: msg.role,
        content: msg.content,
        thinkingSteps: [],
        cards: null,
      }));
    } catch {
      return [];
    }
  }, [getToken]);

  const persistMessage = useCallback(async (role, content) => {
    const token = getToken();
    if (!token) return;
    try {
      await persistMessageWithToken(token, { session_id: sessionId, role, content });
    } catch (e) {
      console.error('Persist error', e);
      throw e; // اجازه دهید safePersistMessage در AIPage خطا را مدیریت کند
    }
  }, [sessionId, getToken]);

  return {
    sessionId,
    setSessionId,
    sessionFull,
    setSessionFull,
    startNewSession,
    loadSessionMessages,
    persistMessage,
  };
}